import { NavItem } from '../../nav/primitives/nav-item';
import { useCallsNavItem } from './use-calls-nav-item';

export const CallsNavItem = () => {
  const item = useCallsNavItem();
  return <NavItem item={item} />;
};
